module.exports = __webpack_public_path__ + "assets/messengerIcon.156a242b.svg";